// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"fb2c678c6bfc1d8f9188","293":"6da7d5382c7a7bedb845"}[chunkId] + ".js";
};